<template>
  <div class="grouped__product">
    <div class="grouped__product-visual">
      <AppLink :to="item.product.product.url">
        <img
          :src="image"
          :alt="item.product.name"
        >
      </AppLink>
    </div>
    <div class="grouped__product-info">
      <ProductInfo
        :product-info="productInfo"
        :product-prices="productPrices"
      />
      <ProductConfigurable
        v-if="item.product.__typename === 'ConfigurableProduct'"
        :key="item.product.sku"
        :product="item.product"
        :stock-data="[]"
        parent-type="GroupedProduct"
        @selected="collect"
      />
      <ProductSimple
        v-else
        :key="item.product.sku"
        :product="item.product"
        :stock-data="[]"
        :optional="true"
        @selected="collect"
      />
    </div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import type { MagentoCartItem } from '~layers/app/types/magento'

export interface Props {
  item: MagentoCartItem
}

const { public: config } = useRuntimeConfig()
const props = defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoCartItemInput>
}>()

const selectedItems = ref<Record<string, MagentoCartItemInput>>({})

watch(selectedItems, () => {
  emit('selected', selectedItems.value)
})

const collect = (item: Record<string, MagentoCartItemInput>) => {
  selectedItems.value = {
    ...selectedItems.value,
    ...item,
  }
}

const productInfo = computed<{ name: string, descriptive: string }>(() => {
  return {
    name: props.item?.product?.product?.name || '',
    descriptive: props.item?.product?.product?.descriptiveName || '',
  }
})

const productPrices = computed<{ regularPrice: number, finalPrice: number }>(() => {
  return {
    regularPrice: props.item?.product?.price_range?.minimum_price?.regular_price?.value,
    finalPrice: props.item?.product?.price_range?.minimum_price?.final_price?.value,
  }
})

const variant = computed(() => props.item.product?.variants?.[0]?.product)

const image = computed<string>(() => {
  if (variant.value?.image?.url && !variant.value?.image?.url.includes('placeholder')) {
    return variant.value?.image?.url.replace('FD/-/', 'OQ75_RM170,1066,255,255,255/-/')
  }

  return `${config.xcdnUrl}OQ75_RM830,1066,255,255,255/-/catalog/product/placeholder/default/Product.FallBack.jpg`
})
</script>
